import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'sonner';
import { queryClient, trpc } from '@/utils/trpc';

export const useGetOrganizationInfo = () => {
  return useQuery({
    ...trpc.organizationsRouter.getOrganizationInfo.queryOptions(),
  });
};

export const useExportPatientDataCsv = () => {
  return useMutation({
    mutationFn: () =>
      queryClient.fetchQuery(
        trpc.organizationsRouter.exportPatientDataCsv.queryOptions(),
      ),
    onError: () => {
      toast.error('Failed to export patient data. Please try again.');
    },
  });
};
